module.exports = __webpack_public_path__ + "static/media/xicon.5917f8ea.svg";